import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import CardHeader from '@zenbusiness/zui/CardHeader';
import Link from '@zenbusiness/zui/Link';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './QACard.style';

function QACard({ actionLabel, externalUrl, schedule, title }) {
  return (
    <Styled.CardWrapper>
      <Styled.ContentWrapper>
        <CardHeader subtitle={schedule} title={<Text size="md">{title}</Text>} />

        <Box display="flex" justifyContent="space-between">
          <Styled.ActionLink
            to={externalUrl}
            target="_blank"
            clickstreamProps={{
              elementName: 'opening_q&a',
              elementValue: title,
            }}
            size="sm"
            weight="medium"
          >
            {actionLabel}
          </Styled.ActionLink>
          <Link
            to={externalUrl}
            target="_blank"
            clickstreamProps={{
              elementName: 'opening_q&a',
              elementValue: title,
            }}
          >
            <SharedAsset
              alt=""
              src="/s2/material-icons/openinnewrounded.svg"
              color="text.blue"
              width="20px"
              height="20px"
            />
          </Link>
        </Box>
      </Styled.ContentWrapper>
    </Styled.CardWrapper>
  );
}

QACard.propTypes = {
  actionLabel: PropTypes.string.isRequired,
  schedule: PropTypes.string.isRequired,
  externalUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default QACard;
